<template>
  <v-wrapper>
    <v-form
      autocomplete="off"
      ref="form"
      v-model="valid"
      @submit.prevent="updateAssessment"
    >
      <v-card flat class="mt-5 pa-2">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="text-h4">Animal Assessment</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="cancelpage"
            outlined
            right
            height="44"
            width="116"
            color="primary"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            right
            class="ml-5"
            height="44"
            width="116"
            color="primary"
            type="submit"
          >
            Submit
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-expansion-panels focusable class="mt-5" v-model="panel" multiple>
            <v-expansion-panel class="mt-5">
              <v-expansion-panel-header class="text-h6 font-weight-bold">{{
                $t("Physical Conformation")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label"
                      >{{ $t("animal.assessmentInfo.bodyConditionScore") }}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          A score of animal with regard to how many fats it has.
                          Condition scores range from 1 (a very thin cow with no
                          fat reserves) to 5 (a severely over-conditioned cow).
                          Ideal condition scores are 3.0-3.25 at dry off and
                          calving, and 2.25-2.75 at peak lactation, with no cows
                          changing condition score class by more than 0.5-0.75
                          over any lactation period.
                        </span>
                      </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="[1, 2, 3, 4, 5]"
                        outlined
                        placeholder="1"
                        dense
                        v-model="physicalConformation.bodyConditionScore"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label"
                      >{{ $t("Teat Size Score") }}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          Teat size can be generally categorized as very small,
                          small, intermediate, large, and very large. This
                          scoring system categorizes udder suspension and teat
                          size. A teat score of 9 (very tight, highly desirable)
                          to 1 (pendulous, not desirable) for udder suspension
                          and a score of 9 (very small) to 1 (very large) for
                          teat size.
                        </span>
                      </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="[9, 7, 5, 3, 1]"
                        outlined
                        placeholder="9"
                        dense
                        v-model="physicalConformation.teatSizeScore"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label"
                      >{{ $t("Udder Suspension Score") }}

                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          Score measuring shape of udder (1-9 score). The
                          strength of attachment of the fore udder to the
                          abdomen. The tighter to the body cavity that the udder
                          is placed, the more desirable. This allows the calf to
                          locate the teats more easily and less likely for the
                          teats to drag in the mud.
                        </span>
                      </v-tooltip></label
                    >
                    <div class="d-flex">
                      <v-select
                        :items="[9, 7, 5, 3, 1]"
                        outlined
                        placeholder="9"
                        dense
                        v-model="physicalConformation.udderSuspensionScore"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label"
                      >{{ $t("Frame Height Score") }}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          Is height-to-age relationship of a beast. It
                          categorises cattle according to their growth and
                          maturity patterns. "Maturity pattern" or "maturity
                          type" refers to the age and size at which an animal
                          tends to "finish", that is, to lay down subcutaneous
                          fat to the level desired by a particular market.
                        </span>
                      </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="[1, 2, 3, 4, 5]"
                        outlined
                        placeholder="9"
                        dense
                        v-model="physicalConformation.frameHeightScore"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label"
                      >{{ $t("Hoof Conformation") }}

                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          Hoof conformation refers to the physical dimensions
                          and shape of the hoof. Good condition hooves enable
                          even weight distribution between the medial and
                          lateral claws of the hoof. Dropdown List .....short
                          toe and steeply angled hoof, a straight fetlock, an
                          upright heel, even claws Overgrown Dipped Bent/twisted
                          claws Splayed claws Normal Hoof
                        </span>
                      </v-tooltip></label
                    >
                    <div class="d-flex">
                      <v-text-field
                        type="text"
                        mode
                        outlined
                        placeholder="High"
                        dense
                        v-model="physicalConformation.hoofConformation"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col aria-colspan="3">
                    <v-btn
                      right
                      class="mt-15 pull-right"
                      color="secondary"
                      @click="addPhysicalConformation"
                    >
                    Update history
                      </v-btn>
                  </v-col>
                </v-row> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-5">
              <v-expansion-panel-header class="text-h6 font-weight-bold">{{
                $t("Behavioural Characteristics")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label"
                      >{{ $t("animal.assessmentInfo.temperament") }}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          Temperament evaluation allows classifying cattle
                          according to the level of responsiveness, from calm to
                          excitable. e.g. docile/ aggressive
                        </span>
                      </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="temperament"
                        item-text="text"
                        item-value="text"
                        outlined
                        placeholder="Select"
                        dense
                        v-model="behaviouralCharacteristics.temperament"
                      ></v-select>
                    </div>
                  </v-col>
                  <!-- <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label">{{$t('animal.assessmentInfo.abnormalBehaviour')}}
                    
                      <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  Abnormal behaviour is defined as an untypical reaction to a particular combination of motivational factors and stimuli. Much abnormal behaviour can be regarded as stress-coping responses. Three categories of abnormalities are discussed: stereotyped motor patterns, abnormal aggression and cannibalism (e.g. agitated, fearful or lying down)
                                </span>
                              </v-tooltip></label>
                    <div class="d-flex">
                      <v-select
                        :items="abnormalBehaviour"
                        item-text="text"
                        item-value="text"
                        outlined
                        placeholder="select"
                        dense
                        v-model="behaviouralCharacteristics.abnormalBehaviour"
                      ></v-select>
                    </div>
                  </v-col> -->
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label"
                      >{{ $t("animal.assessmentInfo.rumination") }}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          Rumination is the process by which the cow
                          regurgitates previously consumed feed and chews it
                          further
                        </span>
                      </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="[
                          { value: 0, text: 'No' },
                          { value: 1, text: 'Yes' },
                        ]"
                        item-text="text"
                        item-value="value"
                        outlined
                        placeholder="Select"
                        dense
                        v-model="behaviouralCharacteristics.rumination"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col
                    :cols="checkBreakPoints ? 6 : 4"
                    v-if="gender === 'Female'"
                  >
                    <label class="label"
                      >{{ $t("animal.assessmentInfo.motheringAbility") }}
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          The mothering ability, the ability of the animal to
                          care for her offsprings is heritable and can respond
                          to selection.The mothering ability could be good or
                          bad.
                        </span>
                      </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['Good', 'Bad']"
                        outlined
                        placeholder="Select"
                        dense
                        v-model="behaviouralCharacteristics.motheringAbility"
                      ></v-select>
                    </div>
                  </v-col>
                  <!-- <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label">{{$t('animal.assessmentInfo.signsOfEstus')}}
                      <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  Other behavior signs of estrus include constant vocalizations, loss of appe- tite, restlessness, and social behaviors such as rubbing up against herd-mates. Physical signs that are demonstrated during estrus include redness and swelling around the vulva, and a thin mucous discharge from the vulva.
                                </span>
                              </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="[{value:0, text:'No'}, {value:1, text:'Yes'}]"
                        item-text="text"
                        item-value="value"
                        outlined
                        placeholder="Select"
                        dense
                        v-model="behaviouralCharacteristics.signsOfEstrus"
                      ></v-select>
                    </div>
                  </v-col> -->
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-5">
              <v-expansion-panel-header class="text-h6 font-weight-bold">{{
                $t("Monitoring Activities")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label">{{
                      $t("animal.assessmentInfo.purpose")
                    }}</label>
                    <div class="d-flex">
                      <v-text-field
                        type="text"
                        outlined
                        dense
                        placeholder="Enter purpose"
                        v-model="monitoringActivities.purpose"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label">{{
                      $t("animal.assessmentInfo.dateIn")
                    }}</label>
                    <v-menu
                      v-model="matingDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="monitoringActivities.dateIn"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          v-on:click:append="matingDateMenu = true"
                          :placeholder="
                            $t(
                              'animal.healthRecordInfo.conceptionInfo.selectDate'
                            )
                          "
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="monitoringActivities.dateIn"
                        @input="matingDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label">{{
                      $t("animal.assessmentInfo.dateOut")
                    }}</label>
                    <v-menu
                      v-model="matingDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="monitoringActivities.dateOut"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          v-on:click:append="matingDateMenu = true"
                          :placeholder="
                            $t(
                              'animal.healthRecordInfo.conceptionInfo.selectDate'
                            )
                          "
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="monitoringActivities.dateOut"
                        @input="matingDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col :cols="checkBreakPoints ? 6 : 4">
                    <label class="label">{{
                      $t("animal.assessmentInfo.remarks")
                    }}</label>
                    <div class="d-flex">
                      <v-text-field
                        type="text"
                        outlined
                        dense
                        placeholder="Enter remarks"
                        v-model="monitoringActivities.remarks"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <!-- <v-row>
                  <v-col aria-colspan="3">
                    <v-btn
                      right
                      class="mt-15 pull-right"
                      color="secondary"
                      @click="addMonitoringActivities"
                    >
                    Update history
                      </v-btn>
                  </v-col>
                </v-row> -->
                  <!-- <v-col :cols="checkBreakPoints ? 6: 4">
                            <label class="label">Conception Method R</label>
                            <v-autocomplete
                                v-model="damId"
                                :items="sireList"
                                :loading="isLoading"
                                :search-input.sync="search"
                                dense
                                outlined
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="animal_number"
                                placeholder="Start typing to Search"
                                return-object
                            ></v-autocomplete>
                        </v-col> -->
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="d-flex justify-end"></div>
        </v-card-text>
      </v-card>
    </v-form>
  </v-wrapper>
</template>
<script>
import {
  weightUnits,
  milkUnits,
  birthEaseTypes,
  totalLongevity,
  timeUnits,
  conceptionMethod,
  abnormalBehaviour,
  temperament,
  bodyConditionScore,
} from "@/models/units.js";

import loading from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
import moment from "moment";

export default {
  // created() {
  //   const fetchData = async () => {
  //     await this.getBreeding();
  //   };
  //   fetchData();
  // },
  data() {
    return {
      panel: [],
      physicalConformation: {},
      behaviouralCharacteristics: {},
      monitoringActivities: {},
      conception: {},
      pregnancyCheck: {},
      conceptionMethod,
      weightUnits,
      milkUnits,
      birthEaseTypes,
      totalLongevity,
      timeUnits,
      animal: {
        animalNumber: this.$route.params.animal_number,
      },
      temperament,
      abnormalBehaviour,
      bodyConditionScore,
      rules: {
        // weight: [(v) => v >= 0 || "Can't be less then 0"],
        // currentWeight: [(v) => v >= 0 || "Can't be less then 0"],
        // estrusDetection: [(v) => v >= 0 || "Can't be less then 0"],
        // matingPeriod: [(v) => v >= 0 || "Can't be less then 0"],
      },
    };
  },
  methods: {
    async updateAssessment() {
      const hasPhysicalConformationChange = Object.keys(
        this.physicalConformation
      ).some(
        key =>
          this.physicalConformation[key] !== this._physicalConformation[key]
      );

      const hasBehaviouralCharacteristicsChange = Object.keys(
        this.behaviouralCharacteristics
      ).some(
        key =>
          this.behaviouralCharacteristics[key] !==
          this._behaviouralCharacteristics[key]
      );

      const hasMonitoringActivitiesChange = Object.keys(
        this.monitoringActivities
      ).some(
        key =>
          this.monitoringActivities[key] !== this._monitoringActivities[key]
      );

      var res;
      if (hasPhysicalConformationChange) {
        res = await this.addPhysicalConformation();
      }

      if (hasBehaviouralCharacteristicsChange) {
        res = await this.addBehaviouralCharacteristics();
      }

      if (hasMonitoringActivitiesChange) {
        res = await this.addMonitoringActivities();
      }

      if (
        hasPhysicalConformationChange ||
        hasBehaviouralCharacteristicsChange ||
        hasMonitoringActivitiesChange
      ) {
        var msg = "Added";
        if (
          (this.createPhysicalConformation &&
            this.createPhysicalConformation.id) ||
          (this.createBehaviouralCharacteristics &&
            this.createBehaviouralCharacteristics.id) ||
          (this.createMonitoringActivities &&
            this.createMonitoringActivities.id)
        ) {
          res = res.data;
          msg = "Updated";
        }

        if (
          (res && res.data.createPhysicalConformation) ||
          res.createPhysicalConformation ||
          res.data.createBehaviouralCharacteristics ||
          res.createBehaviouralCharacteristics ||
          res.data.createMonitoringActivities ||
          res.createMonitoringActivities
        ) {
          this.$notify({
            title: `Assessment record ${msg} successfully`,
            text: res.message,
            type: "success",
            position: "top right",
          });
        } else {
          this.$notify({
            title: `Reproduction Record Not ${msg}`,
            text: res.message,
            type: "error",
            position: "top right",
          });
        }
        this.$emit("assessment:updated");
      }
    },
    async addPhysicalConformation() {
      this.startLoading();
      const mutationPhysicalConformation = `mutation ($data: CreatePhysicalConformationInput!) {
            createPhysicalConformation(createPhysicalConformationInput: $data) {
                id
              }
            }`;
      let physicalConformationData = {
        animalId: parseInt(this.$route.params.animal_number),
        body_condition_score: parseInt(
          this.physicalConformation.bodyConditionScore
        ),
        teat_size_score: this.physicalConformation.teatSizeScore,
        udder_suspension_score: this.physicalConformation.udderSuspensionScore,
        frame_score: this.physicalConformation.frameHeightScore,
        hoof_conformation: this.physicalConformation.hoofConformation,
      };
      return await this.$apollo
        .mutate({
          mutation: gql`
            ${mutationPhysicalConformation}
          `,
          variables: {
            data: physicalConformationData,
          },
        })
        .then(res => {
          // var msg = "Added";
          // if (this.createPhysicalConformation && this.createPhysicalConformation.id) {
          //   res = res.data;
          //   msg = "Updated";
          // }
          // console.log('rk',res)
          if (
            res.data.createPhysicalConformation ||
            res.createPhysicalConformation
          ) {
            // console.log('asfd =>', res.data.createPhysicalConformation);
            // this.$notify({
            //   title: `Assessment record ${msg} successfully`,
            //   text: res.message,
            //   type: "success",
            //   position: "top right",
            // });

            this.$emit("assessment-physical-confrontation:updated");
          } else {
            // this.$notify({
            //   title: `Reproduction Record Not ${msg}`,
            //   text: res.message,
            //   type: "error",
            //   position: "top right",
            // });
          }
          this.stopLoading();
          return res;
        })
        .catch(err => {
          console.log(err);
          this.stopLoading();
        });
    },
    async addBehaviouralCharacteristics() {
      this.startLoading();
      const mutationPhysicalConformation = `mutation ($data: CreateBehaviouralCharacteristicsInput!) {
            createBehaviouralCharacteristics (createBehaviouralCharacteristicsInput: $data) {
              id
            }
          }`;
      let behaviouralData = {
        animalId: parseInt(this.$route.params.animal_number),
        temperament: this.behaviouralCharacteristics.temperament,
        // abnormal_behaviour: this.behaviouralCharacteristics.abnormalBehaviour,
        rumination: Boolean(this.behaviouralCharacteristics.rumination),
        mothering_ability: this.behaviouralCharacteristics.motheringAbility,
        // signs_of_estrus: Boolean(this.behaviouralCharacteristics.signsOfEstrus),
      };
      return await this.$apollo
        .mutate({
          mutation: gql`
            ${mutationPhysicalConformation}
          `,
          variables: {
            data: behaviouralData,
          },
        })
        .then(res => {
          // var msg = "Added";
          // if (this.createBehaviouralCharacteristics && this.createBehaviouralCharacteristics.id) {
          //   res = res.data;
          //   msg = "Updated";
          // }
          // console.log(res);
          // console.log('rk',res)
          if (
            res.data.createBehaviouralCharacteristics ||
            res.createBehaviouralCharacteristics
          ) {
            // this.$notify({
            //   title: `Assessment record ${msg} successfully`,
            //   text: res.message,
            //   type: "success",
            //   position: "top right",
            // });
            this.$emit("assessment-behavioural-characteristics:updated");
          } else {
            // this.$notify({
            //   title: `Assessment Record Not ${msg}`,
            //   text: res.message,
            //   type: "error",
            //   position: "top right",
            // });
          }
          this.stopLoading();
          return res;
        })
        .catch(err => {
          console.log(err.data);
          this.stopLoading();
        });
    },
    async addMonitoringActivities() {
      this.startLoading();
      const monitoringActivitiesMutation = `mutation ($data: CreateMonitoringActivitiesInput!) {
          createMonitoringActivities (createMonitoringActivitiesInput: $data) {
              id
            }
          }`;
      let monitoringActivitiesData = {
        animalId: parseInt(this.$route.params.animal_number),
        purpose: this.monitoringActivities.purpose,
        date_in: this.monitoringActivities.dateIn,
        date_out: this.monitoringActivities.dateOut,
        remarks: this.monitoringActivities.remarks,
      };
      return await this.$apollo
        .mutate({
          mutation: gql`
            ${monitoringActivitiesMutation}
          `,
          variables: {
            data: monitoringActivitiesData,
          },
        })
        .then(res => {
          // var msg = "Added";
          // if (this.createMonitoringActivities && this.createMonitoringActivities.id) {
          //   res = res.data;
          //   msg = "Updated";
          // }
          // console.log('rk',res)
          // console.log('monitoring act', res);
          if (
            res.data.createMonitoringActivities ||
            res.createMonitoringActivities
          ) {
            // this.$notify({
            //   title: `Assessment record ${msg} successfully`,
            //   text: res.message,
            //   type: "success",
            //   position: "top right",
            // });
            this.$emit("assessment-monitoring-activity:updated");
          } else {
            // this.$notify({
            //   title: `Assessment Record Not ${msg}`,
            //   text: res.message,
            //   type: "error",
            //   position: "top right",
            // });
          }
          this.stopLoading();
          return res;
        })
        .catch(err => {
          console.log(err);
          this.stopLoading();
        });
    },

    cancelpage() {
      this.$emit("assessment-update:cancel");
    },
  },
  mixins: [loading],
  mounted() {
    this.physicalConformation = Object.assign({}, this._physicalConformation);
    this.behaviouralCharacteristics = Object.assign(
      {},
      {
        ...this._behaviouralCharacteristics,
        rumination: this._behaviouralCharacteristics.rumination ? 1 : 0,
      }
    );
    (this.monitoringActivities = Object.assign(
      {},
      {
        ...this._monitoringActivities,
        dateIn: this._monitoringActivities.dateIn
          ? moment(this._monitoringActivities.dateIn).format("YYYY-MM-DD")
          : null,
        dateOut: this._monitoringActivities.dateOut
          ? moment(this._monitoringActivities.dateOut).format("YYYY-MM-DD")
          : null,
      }
    )),
      (this.gender = this._gender);
  },
  props: {
    _physicalConformation: {
      required: true,
      type: Object,
    },
    _behaviouralCharacteristics: {
      required: true,
      type: Object,
    },
    _monitoringActivities: {
      required: true,
      type: Object,
    },
    _gender: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scopped>
label {
  display: inline-block;
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
</style>
